<script lang="ts">
  import { mdiRefresh } from "@mdi/js"
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"
  import { Circle } from "svelte-loading-spinners"

  const {
    message,
    variant = "info",
    retryLabel = "",
    onRetry = undefined,
  } = $props<{
    message: string
    variant?: "loading" | "info" | "error"
    retryLabel?: string
    onRetry?: (() => Promise<void> | void) | undefined
  }>()
</script>

<div
  class="contact-method-state"
  class:loading={variant === "loading"}
  class:error={variant === "error"}
  role={variant === "loading" ? "status" : undefined}
  aria-live={variant === "loading" ? "polite" : undefined}
>
  {#if variant === "loading"}
    <Circle size="2.25" color="var(--primary-100)" unit="rem" />
  {/if}
  <p>{message}</p>
  {#if retryLabel && onRetry}
    <CTA
      type="tertiaryButton"
      icon={mdiRefresh}
      content={retryLabel}
      onClick={onRetry}
      darkMode={false}
      small={true}
    />
  {/if}
</div>

<style lang="less">
  .contact-method-state {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    min-height: 4rem;

    p {
      color: var(--text-invers-100);
      line-height: 1.45;
      margin: 0;
    }

    &.loading {
      justify-content: center;
      text-align: center;
    }

    &.error p {
      color: var(--red-200, #b42318);
      font-weight: 700;
    }
  }
</style>
